import { type WorkoutItemGroupType } from "api-client/legacy-trpc";
import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { SectionTypeField } from "./SectionTypeField";
import { useGroupUpdate } from "./useGroupUpdate";

interface RegularHeaderFieldsProps {
  workoutItemId: string;
}

export const RegularHeaderFields = observer(function RegularHeaderFields(
  props: RegularHeaderFieldsProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getGroupWorkoutItemById(
    props.workoutItemId,
  );
  const { handleUpdate } = useGroupUpdate(props.workoutItemId);

  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <div
      className="flex items-center gap-3 shrink-0"
      onClick={handleStopPropagation}
    >
      <SectionTypeField
        value={workoutItem.groupType}
        onChange={(value: WorkoutItemGroupType) => {
          handleUpdate({ groupType: value });
        }}
      />
    </div>
  );
});
